import {
  ACTION_PUT_ORG_SPECIAL_RATE_CODES,
  ACTION_PUT_ORG_SPECIAL_RATE_CODES_SUCCESS,
  ACTION_PUT_ORG_SPECIAL_RATE_CODES_FAILURE,
  API_CALL,
} from '../../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../../Status';

export function putSpecialRateCodes(organizationId: string, value: any) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/specialRates`,
        method: 'put',
        data: JSON.stringify({ value }),
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_ORG_SPECIAL_RATE_CODES,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_PUT_ORG_SPECIAL_RATE_CODES_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_PUT_ORG_SPECIAL_RATE_CODES_FAILURE,
    payload: responseJSON,
  };
}
